import { Grid, Container } from '@mui/material';
import MKBox from 'components/MKBox';
import MKTypography from 'components/MKTypography';

import news_insights_pic from 'assets/csdd_images/news_and_insights.jpg';
import { KeyboardDoubleArrowDownSharp } from '@mui/icons-material';

const NewsHeader = () => {
  return (
    <MKBox
      minHeight='75vh'
      width='100%'
      sx={{
        backgroundImage: ({
          functions: { linearGradient, rgba },
          palette: { gradients },
        }) =>
          `${linearGradient(
            rgba(gradients.dark.main, 0.6),
            rgba(gradients.dark.state, 0.6)
          )}, url(${news_insights_pic})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        display: 'grid',
        placeItems: 'center',
      }}
    >
      <Container>
        <Grid
          container
          item
          xs={12}
          lg={8}
          justifyContent='center'
          alignItems='center'
          flexDirection='column'
          sx={{ mx: 'auto', textAlign: 'center' }}
        >
          <MKTypography
            variant='h1'
            color='white'
            sx={({ breakpoints, typography: { size } }) => ({
              [breakpoints.down('md')]: {
                fontSize: size['3xl'],
              },
            })}
          >
            News & Insights
          </MKTypography>
          <MKTypography
            variant='body1'
            color='white'
            opacity={0.8}
            mt={1}
            mb={3}
          >
            Find here all the latest news and updates in the procurement and
            supply chain space
          </MKTypography>
          <MKBox component='a' href='#start'>
            <KeyboardDoubleArrowDownSharp
              fontSize='large'
              color='warning'
              sx={{ '&:hover': { color: 'white.main' } }}
            />
          </MKBox>
        </Grid>
      </Container>
    </MKBox>
  );
};
export default NewsHeader;
